import { jsx, Fragment } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useSelectCommonActionsContext, useSelectCommonContext } from "../context/SelectContext.js";
import "../../../Button/Button.js";
import "../../../InputControl/InputControl.js";
import "../../../InputControl/Input/InputBase.js";
import "../../../PhoneInputControl/PhoneInputControl.js";
import "../../../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../../IconButton/IconButton.js";
import "react";
import "../../../common/ControlBody.js";
import "../../../Dialog/Dialog.js";
import "../../../IconButtonNew/IconButton.js";
import "../../../../icons/24/Action/Close.js";
import "../../../../icons/24/Arrow/ChevronLeft.js";
import { inheritDataTestId } from "../../../../utils/dataTestId.js";
import "./SelectInput/SelectInput.js";
import { DATA_TEST_ID_INHERITED } from "../../../../constants/DATA_TEST_ID_INHERITED.js";
import "../MultiSelect/context/MultiSelectContext.js";
import { CheckIcon } from "../../../../icons/24/System/Check.js";
import { highlightMatches } from "../../../../utils/highlightMatches.js";
import "../../../../icons/24/Arrow/ChevronDown.js";
import "../../../TextareaControl/TextareaControl.js";
import "../../../SearchControl/SearchControl.js";
import "../../../../icons/24/System/Search.js";
import "../../../FormattedPhone/FormattedPhoneNumber.js";
import "../../../Avatar/styles.js";
import { Checkbox } from "../../../CheckboxGroup/Checkbox/Checkbox.js";
import "../../../CheckboxGroup/styles.js";
import "../../../RadioGroup/Radio/styles.js";
import "../../../RadioGroup/styles.js";
import "../../../RatingButton/styles.js";
import "../../../FloatingActionButton/styles.js";
import "../../../SortingButton/styles.js";
import "../../../SquareButton/styles.js";
import "../../../Toggle/styles.js";
import "../../../Dialog/StyledDialog.js";
import "../../../Chips/Chip/styles.js";
import "../../../ResultMarksNumber/styles.js";
import "../../../Progress/ProgressCircle/styles.js";
import "../../../Loaders/LoaderCircle/styles.js";
import "../../../Loaders/LoaderLine/styles.js";
import "../../../SegmentedControl/styles.js";
import "../../../ResultMarksText/styles.js";
import "../../../Link/styles.js";
import "../../../Tag/Tag.js";
import "../../../DatePicker/constants.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../../external/classnames/index.js";
import "../../../Scrollbar/Scrollbar.js";
import "../../../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../../MobileBottomSheet/MobileBottomSheet.js";
import { ListItem } from "../../../List/ListItem/ListItem.js";
import { ListItemText } from "../../../List/ListItem/ListItemText.js";
import "../../../List/ListItemTree/TreeListItem.js";
import "../../../List/ListItemTree/components/Label.js";
import "../../../Nowrap.js";
const highlight = (str, substring) => {
  const offset = str.toLowerCase().indexOf(substring.toLowerCase());
  return offset === -1 ? str : /* @__PURE__ */ jsx(Fragment, { children: highlightMatches(str, [{ length: substring.length, offset }]) });
}, highlightSelected = (children, filter) => typeof children == "string" && filter ? highlight(children, filter) : children, MenuItem = ({
  children,
  value,
  raw,
  ...props
}) => {
  const actions = useSelectCommonActionsContext(), ctx = useSelectCommonContext(), isMulti = "multi" in actions && "multi" in ctx, handleClick = () => {
    if (value != null)
      if (isMulti) {
        const val = [...ctx.value ?? []], currentlyChecked = val.includes(value);
        currentlyChecked ? val.splice(val.indexOf(value), 1) : val.push(value), actions.onChange({
          value: val,
          option: { value, checked: !currentlyChecked }
        });
      } else
        actions.onChange({
          value,
          option: { value, checked: !0 }
        });
  }, selected = typeof value < "u" && ctx.value === value || Array.isArray(ctx.value) && ctx.value.includes(value ?? ""), rawContent = raw;
  return /* @__PURE__ */ jsx(
    ListItem,
    {
      "data-test-id": DATA_TEST_ID_INHERITED,
      ...props,
      onMouseUp: handleClick,
      selected: isMulti ? void 0 : selected,
      startAdornment: isMulti && /* @__PURE__ */ jsx(
        Checkbox,
        {
          "data-test-id": inheritDataTestId(props, "checkbox"),
          value: selected,
          sx: { ".MuiCheckbox-root": { margin: 0 } }
        }
      ),
      endAdornment: rawContent ? void 0 : selected && !isMulti ? /* @__PURE__ */ jsx(CheckIcon, {}) : /* @__PURE__ */ jsx("div", { style: { width: 24, height: 24 } }),
      children: rawContent ? children : /* @__PURE__ */ jsx(Stack, { direction: "row", children: /* @__PURE__ */ jsx(ListItemText, { variant: "text", lines: 4, children: highlightSelected(children, ctx.filter) }) })
    }
  );
};
export {
  MenuItem
};
//# sourceMappingURL=MenuItem.js.map
